import types from '../types';

export default {
  state: {
    user: null,
    access_token: null,
    auth: null,
    userInfo: null,
  },
  mutations: {
    [types.SET_AUTH](state, data) {
      state.user = data.user ? data.user : {};
      state.access_token = data.access_token;
      state.auth = data;
      localStorage.setItem('kw_scanner_auth', JSON.stringify(data));
    },
    removeAuthentication(state) {
      state.auth = {};
      state.userInfo = {};
      localStorage.setItem('kw_scanner_auth', JSON.stringify(state.auth));
      // session.clear()
    },
  },
  actions: {
    [types.GET_AUTH]({ commit }) {
      let auth = {};
      try {
        auth = JSON.parse(localStorage.getItem('kw_scanner_auth') || '{}');
      } catch (e) {
        auth = {
          token: null,
          user: null,
          access_token: null,
          grant_type: 'password',
          token_type: 'Bearer',
        };
      }
      commit(types.SET_AUTH, auth);
      return auth;
    },
  },
  getters: {
    getAuth(state) {
      return state.auth;
    },
    isAuthenticated(state) {
      return state.auth && state.auth.access_token && typeof state.auth.access_token !== 'undefined';
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js